import { ApiService } from '../../service/api/ApiService'

/**
 * @type {string} Endpoint получения всех компаний
 */
const allCounterpartyEndpoint = 'counterparty'

/**
 * Метод получающий компании.
 *
 * @param context Стейт
 * @returns {Promise<null|*>}
 */
const findAllCounterpartiesByAuthUser = async (context) => {
  context.commit('fetchCounterparties')
  try {
    const { data } = await ApiService.get(allCounterpartyEndpoint)
    const response = data.data === undefined ? [] : data.data
    context.commit('fetchCounterpartiesSuccess', response)
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchCounterpartiesError', error)
    return null
  }
}

export default {
  findAllCounterpartiesByAuthUser,
}
